/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a Variant Category
 * @export
 * @interface VariantCategory
 */
export interface VariantCategory {
    /**
     * Variant category name
     * @type {string}
     * @memberof VariantCategory
     */
    name?: string;
    /**
     * Flag if varian category has image assigned
     * @type {boolean}
     * @memberof VariantCategory
     */
    hasImage?: boolean;
    /**
     * Priority number of variant category
     * @type {number}
     * @memberof VariantCategory
     */
    priority?: number;
}

/**
 * Check if a given object implements the VariantCategory interface.
 */
export function instanceOfVariantCategory(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VariantCategoryFromJSON(json: any): VariantCategory {
    return VariantCategoryFromJSONTyped(json, false);
}

export function VariantCategoryFromJSONTyped(json: any, ignoreDiscriminator: boolean): VariantCategory {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
        'hasImage': !exists(json, 'hasImage') ? undefined : json['hasImage'],
        'priority': !exists(json, 'priority') ? undefined : json['priority'],
    };
}

export function VariantCategoryToJSON(value?: VariantCategory | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'hasImage': value.hasImage,
        'priority': value.priority,
    };
}

